import { render, staticRenderFns } from "./EditSEO.vue?vue&type=template&id=72506b9b&scoped=true"
import script from "./EditSEO.vue?vue&type=script&lang=js"
export * from "./EditSEO.vue?vue&type=script&lang=js"
import style0 from "./EditSEO.vue?vue&type=style&index=0&id=72506b9b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72506b9b",
  null
  
)

export default component.exports